import { Button } from "@/components/ui/button";

interface ButtonData {
  text: string;
  url: string;
  variant: "primary" | "outline";
}

interface CTASectionProps {
  title: string;
  subtitle: string;
  content: string;
  buttons?: ButtonData[];
  backgroundColor?: string;
  onButtonClick?: (url: string, text: string) => void;
}

export function CTASection({ title, subtitle, content, buttons = [], backgroundColor, onButtonClick }: CTASectionProps) {
  return (
    <section
      className="relative py-16 sm:py-24 px-4 overflow-hidden"
      style={{ backgroundColor: backgroundColor || undefined }}
    >
      {/* Gradient background when no custom color */}
      {!backgroundColor && (
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-primary/5 to-background" />
      )}

      <div className="relative max-w-3xl mx-auto text-center space-y-6">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground tracking-tight">{title}</h2>
        {subtitle && (
          <p className="text-lg font-semibold text-primary">{subtitle}</p>
        )}
        {content && (
          <p className="text-muted-foreground text-base sm:text-lg leading-relaxed">{content}</p>
        )}
        {buttons.length > 0 && (
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            {buttons.map((btn, i) => (
              <Button
                key={i}
                variant={btn.variant === "outline" ? "outline" : "default"}
                size="lg"
                className={`text-base px-10 py-6 font-semibold transition-all duration-300 ${
                  btn.variant !== "outline"
                    ? "shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-0.5 animate-pulse-slow"
                    : "hover:-translate-y-0.5"
                }`}
                asChild
              >
                <a href={btn.url} target="_blank" rel="noopener noreferrer" onClick={() => onButtonClick?.(btn.url, btn.text)}>{btn.text}</a>
              </Button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
